import { ColorRecipeModel } from '../edit/models/color-recipe.model';
import { Store } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineService } from './engine.service';
import { PaintPresetOriginal, PaintPresetFade } from './models/paint-presets.const';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../lib/graph/graph.service";
import * as i3 from "./engine.service";
var PaintService = /** @class */ (function () {
    function PaintService(store, graphService, engineService) {
        this.store = store;
        this.graphService = graphService;
        this.engineService = engineService;
    }
    PaintService.prototype.paint = function (node, recipe) {
        var _this = this;
        // relay color mods to each engine leaf
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach(function (id) {
            _this.engineService.getObjects(id).forEach(function (humanObjectId) {
                var humanObject = Human.scene.objects[humanObjectId];
                if (humanObject instanceof Human.scene.Object) {
                    var engineRecipe = ColorRecipeModel.toEngine(recipe);
                    // reset object mod properties
                    humanObject.clearColorModProperties();
                    humanObject.clearOpacityModProperties();
                    // apply mod properties that are not default
                    if (engineRecipe.hasOwnProperty('tintColor')) {
                        humanObject.setTintColor(engineRecipe.tintColor);
                    }
                    if (engineRecipe.hasOwnProperty('saturation')) {
                        humanObject.setSaturation(engineRecipe.saturation);
                    }
                    if (engineRecipe.hasOwnProperty('brightness')) {
                        humanObject.setBrightness(engineRecipe.brightness);
                    }
                    if (engineRecipe.hasOwnProperty('contrast')) {
                        humanObject.setContrast(engineRecipe.contrast);
                    }
                    if (engineRecipe.hasOwnProperty('opacity')) {
                        humanObject.setOpacity(engineRecipe.opacity);
                    }
                }
            });
        });
    };
    PaintService.prototype.highlight = function (node, highlight) {
        var _this = this;
        // relay highlight to each engine leaf
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach(function (id) {
            _this.engineService.getObjects(id).forEach(function (humanObjectId) {
                var humanObject = Human.scene.objects[humanObjectId];
                if (humanObject instanceof Human.scene.Object) {
                    humanObject.setHighlight(highlight);
                }
            });
        });
    };
    PaintService.prototype.xRay = function (node, xRay) {
        var object = Human.scene.objects[node.id];
        object.setXRay(xRay);
    };
    PaintService.prototype.paintAll = function (nodes, recipe) {
        var _this = this;
        nodes.forEach(function (node) {
            _this.paint(node, recipe);
        });
    };
    PaintService.prototype.highlightAll = function (nodes, highlight) {
        var _this = this;
        nodes.forEach(function (node) {
            _this.highlight(node, highlight);
        });
    };
    PaintService.prototype.inverseXRay = function (nodes, viewGraph) {
        var nodeIds = nodes.map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(viewGraph, nodeIds);
        var inverseNodes = this.graphService.getNodes(viewGraph, inverseNodeIds);
        this.paintAll(inverseNodes, PaintPresetFade.recipe);
        this.paintAll(nodes, PaintPresetOriginal.recipe);
    };
    PaintService.ngInjectableDef = i0.defineInjectable({ factory: function PaintService_Factory() { return new PaintService(i0.inject(i1.Store), i0.inject(i2.BdGraphService), i0.inject(i3.EngineService)); }, token: PaintService, providedIn: "root" });
    return PaintService;
}());
export { PaintService };
